import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider } from '@wise/components-theming';
import { calculateSavingsWithRespectToWiseQuote } from '../resources/savingsCalculator';
import { trackFeePopoverClicked, trackTableViewed } from '../resources/tracking';
import { Table } from '../resources/tracking/types';
import styles from './TransferFeeComparisonContainer.module.less';
import { transformV2ToComparisonQuote } from './domain/Quote';
import TransferFeeComparisonFooter from './transfer-fee-comparison-footer';
import TransferFeeComparisonHeader from './transfer-fee-comparison-header';
import TransferFeeComparisonTable from './transfer-fee-comparison-table';
const getTrackingContext = (sendAmount, quotes, route, midMarketRate, excludePartners, showSpeed = false, showFastestFlag = false) => {
    const comparisonQuotes = quotes.map((quote) => transformV2ToComparisonQuote(quote));
    return {
        amount: sendAmount.value,
        source: route.sourceCurrency,
        target: route.targetCurrency,
        quotes: comparisonQuotes,
        componentType: Table.TransferFee,
        savingsAgainstWise: calculateSavingsWithRespectToWiseQuote(comparisonQuotes, excludePartners),
        showSpeed: showSpeed,
        showFastestFlag: showFastestFlag,
        midMarketRate: { rate: midMarketRate },
    };
};
export const TransferFeeComparisonContainer = ({ sendAmount, quotes, route, midMarketRate, trackEvent = () => {
    /* do nothing. */
}, excludePartners = true, showSpeed = false, showFastestFlag = false, }) => {
    const filteredQuotes = excludePartners
        ? quotes.filter((quote) => !quote.provider.partner)
        : quotes;
    const context = getTrackingContext(sendAmount, filteredQuotes, route, midMarketRate, excludePartners, showSpeed, showFastestFlag);
    const onCentreProviderView = () => {
        trackTableViewed(context, trackEvent);
    };
    const onFeePopoverClick = (providerName) => {
        const trackingContext = Object.assign(Object.assign({}, context), { providerName });
        trackFeePopoverClicked(trackingContext, trackEvent);
    };
    return (_jsxs("div", Object.assign({ className: styles.transferFeeComparison__container }, { children: [_jsx("div", Object.assign({ className: styles.transferFeeComparison__header }, { children: _jsx(TransferFeeComparisonHeader, { showSpeed: showSpeed }) })), _jsx(ThemeProvider, Object.assign({ theme: "personal", screenMode: "light", className: styles.transferFeeComparison__table }, { children: _jsx(TransferFeeComparisonTable, { sendAmount: sendAmount, quotes: filteredQuotes, route: route, midmarketRate: midMarketRate, showSpeed: showSpeed, showFastestFlag: showFastestFlag, onCentreProviderView: onCentreProviderView, onFeePopoverClick: onFeePopoverClick }) })), _jsx("div", Object.assign({ className: styles.transferFeeComparison__footer }, { children: _jsx(TransferFeeComparisonFooter, {}) }))] })));
};
export default TransferFeeComparisonContainer;
